import { ButtonERP } from "@finanedi.es/storybook"
import { PerceptorGetDatosDeclaracionModelo190DtoProps } from "api/DTOs/PerceptorGetDatosDeclaracionModelo190Dto"
import { UseFormSetValue } from "react-hook-form"
import { useTranslation } from "react-i18next"
import OperadoresTemplate from "./OperadoresTemplate"

const Operadores349 = ({
  setValue,
  values,
}: {
  setValue: UseFormSetValue<$TSMigrationFixMe>
  values: $TSMigrationFixMe
}) => {
  const { t } = useTranslation()
  const operadoresCount = values?.operadores?.length ?? 1
  const handleAddInmueble = () => {
    const current = Array.isArray(values?.operadores) ? values.operadores : []
    const newInmueble = {}
    setValue("operadores", [...current, newInmueble], {
      shouldValidate: false,
      shouldDirty: true,
      shouldTouch: true,
    })
  }

  const handleDeleteInmueble = (index: number) => {
    const current = Array.isArray(values?.operadores) ? values.operadores : []
    const updated = current.filter(
      (_: PerceptorGetDatosDeclaracionModelo190DtoProps, idx: number) =>
        idx !== index
    )
    setValue("operadores", updated, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    })
  }

  return (
    <div
      title='Operadores'
      className='tw-w-full tw-px-4 tw-pb-4 tw-space-y-5'
    >
      <ButtonERP
        label={`${t("declaracionModelo349.addOperator")}`}
        customize={{ type: "primary", size: "md" }}
        onClick={handleAddInmueble}
      />

      {Array.from({ length: operadoresCount }).map((_, index) => (
        <OperadoresTemplate
          t={t}
          // eslint-disable-next-line react/no-array-index-key
          key={`operadores_${index}`}
          text={`${t("declaracionModelo349.operator")} ${index + 1}`}
          values={values}
          setValue={setValue}
          operadorIndex={index}
          handleDelete={() => handleDeleteInmueble(index)}
        />
      ))}
    </div>
  )
}

export default Operadores349
